import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/fbPixel';

export default function ScrollToTop() {
  const { pathname, key } = useLocation();

  // Use useLayoutEffect for synchronous scroll before paint
  useLayoutEffect(() => {
    // Immediate scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    
    // Also reset any scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, [pathname, key]);

  // Fire Meta Pixel PageView on every SPA route change (initial PageView
  // is fired by the base pixel script in public/index.html)
  useEffect(() => {
    trackPageView();
  }, [pathname]);

  // Additional effect for handling browser back/forward
  useEffect(() => {
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    const handlePopState = () => {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }, 0);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return null;
}
